import {useState} from "react";
import React from "react";
import {css} from "@emotion/css";
import {PaymentGatewayService} from "../../serverService/paymentGatewayService/PaymentGatewayService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {PaymentGatewayTypes} from "../../serverService/enums/PaymentGatewayTypes";
import {
    RaikoButtonPrimary,
    RaikoCustomSelect, raikoCustomSelectItemGenerator, RaikoFlexAlignEnd,
    RaikoGridOneColumn,
    RaikoMaterialOutlinedInput, showErrorMessage,
    showSuccessMessage, showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";


export default function AddNewPaymentGateway({addNewGateway}) {

    const service = new PaymentGatewayService()
    const loading = new LoadingHelper(useLoadingDispatcher())


    const [title, setTitle] = useState("")
    const [type, setType] = useState(PaymentGatewayTypes.ZARINPAL.id)

    function handleAddNewPaymentGateway() {
        if (checkFields()) {
            loading.show()
            service.addNewGateway(title, type)
                .then(response => {
                    addNewGateway(response)
                    setTitle("")
                    setType(PaymentGatewayTypes.ZARINPAL.id)

                    showSuccessMessage("درگاه جدید با موفقیت افزوده شد.")
                }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        }
    }

    function checkFields() {
        let state = false
        let message = ""

        if (title.length === 0) {
            message = "لطفا عنوان درگاه مورد نظر را وارد نمایید."
        } else {
            state = true
        }


        showWarningMessage(message)
        return state
    }


    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem`}>
            <RaikoMaterialOutlinedInput
                labelText={"عنوان"}
                setValue={setTitle}
                value={title}/>
            <RaikoCustomSelect
                value={type}
                setValue={setType}
                labelText={"نوع"}
                items={[raikoCustomSelectItemGenerator(PaymentGatewayTypes.ZARINPAL.id, PaymentGatewayTypes.ZARINPAL.name)]}
            />
            <RaikoFlexAlignEnd>
                <RaikoButtonPrimary
                    label={"افزودن"}
                    onClick={handleAddNewPaymentGateway}
                />
            </RaikoFlexAlignEnd>
        </RaikoGridOneColumn>

    )
}